var React = require('react');

function Idenetity (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"IDENTITA w","transform":"translate(-40 -1078)"},React.createElement("g",{"data-name":"IDENTITA ikona","transform":"translate(46.3 1086.1)"},[React.createElement("path",{"data-name":"Path 198","d":"M1.5,11.236S4.118,6,8.7,6s7.2,5.236,7.2,5.236-2.618,5.236-7.2,5.236S1.5,11.236,1.5,11.236Z","transform":"translate(-1.5 -6)","fill":"none","stroke":"#2f2e2e","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":0}),React.createElement("path",{"data-name":"Path 199","d":"M17.427,15.464A1.964,1.964,0,1,1,15.464,13.5,1.964,1.964,0,0,1,17.427,15.464Z","transform":"translate(-8.264 -10.227)","fill":"none","stroke":"#2f2e2e","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1})])));
}

Idenetity.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27"};

module.exports = Idenetity;

Idenetity.default = Idenetity;
